import type { TrainingRoutineTemplate, WithOptionalId } from '../types';

export const getEmptyTemplate = (
  name: string,
  level: number,
  fitnessGoal: string,
  isPrivate: boolean,
  trainerId: string,
): WithOptionalId<TrainingRoutineTemplate> => ({
  name,
  isPrivate,
  trainerIds: [trainerId],
  routine: {
    name,
    description: '',
    exerciseGroups: [],
    templateInfo: {
      level,
      trainerId,
      fitnessGoals: [fitnessGoal],
      workoutCategory: '',
    },
  },
});
